import styled from 'styled-components';
import theme from 'styles/theme';
import { FIELD_HEIGHT } from '../../DirectBookingEngine.styles';

type ToggleProps = { $isSelected: boolean; $isConfigured: boolean };

const getBorderColor = ({ $isSelected, $isConfigured }: ToggleProps) =>
  $isSelected || $isConfigured ? theme.colors.hostfullyBlue : '#949494';

const getGlyphColor = ({ $isSelected, $isConfigured }: ToggleProps) => {
  if ($isSelected) {
    return '#fff';
  }

  return $isConfigured ? theme.colors.hostfullyBlue : '#3a3a52';
};

export const SocialIconsRowStyled = styled.div`
  align-items: center;
  display: flex;

  & > .tooltip-container {
    margin-left: auto;
  }
`;

export const SocialIconsGridStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SocialIconToggleStyled = styled.button<ToggleProps>`
  align-items: center;
  background: ${({ $isSelected }) =>
    $isSelected ? theme.colors.hostfullyBlue : '#fff'};
  border: 1px solid ${getBorderColor};
  border-radius: 6px;
  color: ${getGlyphColor};
  display: flex;
  height: ${FIELD_HEIGHT};
  justify-content: center;
  padding: 0;
  position: relative;
  width: ${FIELD_HEIGHT};

  // Height-only, so every glyph reads at the same optical size: the brand viewBoxes are
  // not square, and fixing both axes would letterbox the wide ones to a smaller height.
  svg {
    height: 16px;
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.hostfullyBlue};
    outline-offset: 2px;
  }
`;

// A shape cue, because indigo and the default glyph color have all but identical
// luminance (1.04:1) — on their own they carry no contrast, only hue.
export const ConfiguredDotStyled = styled.span`
  background: ${theme.colors.hostfullyBlue};
  border: 1px solid #fff;
  border-radius: 50%;
  height: 8px;
  position: absolute;
  right: -2px;
  top: -2px;
  width: 8px;
`;

export const SocialIconsUrlStyled = styled.div`
  margin-top: 8px;

  .form-field-container {
    margin-bottom: 0;
  }

  // The nested field renders its own bootstrap column, whose gutter would inset the
  // input against the toggles and against every other control in the section.
  .form-field-container > div {
    padding-left: 0;
    padding-right: 0;
  }
`;
